// Module
var code = "<div> <div class=\"links_footer flex space-x-4 noprint hidden md:block\"> <div class=\"regionLinks basis-6/12 tight\" ng-bind-html=\"one|unsafe\"></div> <div class=\"regionLinks basis-6/12\" ng-bind-html=\"two|unsafe\"></div> </div> <div ng-bind-html=\"three|unsafe\"></div> </div> ";
// Exports
var _module_exports =code;;
var path = '/codebuild/output/src2431095171/src/frontend/js/directives/public/searchPageFooter.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;